<template>
  <b-col>
    <h1>{{ project.name }}</h1>
    <b-row>
      <b-col lg="6">
        <b-card>

          <b-media vertical-align="center">
            <template v-slot:aside>
              <b-avatar variant="info" size="lg">
                <fa-icon icon="chart-bar" />
              </b-avatar>
            </template>
            <h5 class="mt-0">Статистика</h5>
            <p>Система учитывает входящие и исходящие вызовы за всю историю работы проекта, а также историю Call-tracking..</p>
            <b-button variant="light" size="sm" :to="{name: 'statistics-overview', params: {projectId: projectId}}">
              <fa-icon icon="chart-pie"/> Перейти в статистику
            </b-button>
          </b-media>
          <hr/>
          <b-media vertical-align="center">
            <template v-slot:aside>
              <b-avatar variant="info" size="lg">
                <fa-icon icon="phone-volume" />
              </b-avatar>
            </template>
            <h5 class="mt-0">Звонки</h5>
            <p>Система хранит историю всех входящих вызовов на виртуальную АТС, вне зависимости от того, занесён ли номер в систему в разделе "Номера" или нет.</p>
            <b-button variant="light" size="sm" :to="{name: 'call-list', params: {projectId: projectId}}">
              <fa-icon icon="list"/> Список звонков
            </b-button>
          </b-media>
          <hr/>
          <b-media vertical-align="center">
            <template v-slot:aside>
              <b-avatar variant="info" size="lg">
                <fa-icon icon="phone-alt" />
              </b-avatar>
            </template>
            <h5 class="mt-0">Номера</h5>
            <p>В системе заводятся номера, которым можно давать отдельные имена и использовать их для колл-трекинга. Номера, не внесённые в систему, всё равно учитываются в статистике звонков.</p>
            <b-button variant="light" size="sm" :to="{name: 'phone-list', params: {projectId: projectId}}">
              <fa-icon icon="external-link-alt"/> Список номеров
            </b-button>
          </b-media>
          <hr/>
          <b-media vertical-align="center">
            <template v-slot:aside>
              <b-avatar variant="info" size="lg">
                <fa-icon icon="dot-circle" />
              </b-avatar>
            </template>
            <h5 class="mt-0">Call-tracking</h5>
            <p>Номера, заведённые в системе, могут быть использованы для колл-трекинга. В настройке номера можно указать критерии, по которым он подменяет номер на сайте.</p>
          </b-media>
        </b-card>
      </b-col>

      <b-col lg="6">

        <b-card title="Обзор">
          <b-overlay :show="!stats">
            <b-card-text>
              <ShortStats :stats="stats" />
            </b-card-text>
          </b-overlay>
        </b-card>

        <b-card no-body class="mt-3" v-if="stats">

          <b-tabs card>
            <b-tab title="Всего" active lazy>
              <pie-chart
                :height="null"
                :width="null"
                :chartData="chartDataAll"/>
            </b-tab>
            <b-tab title="Входящие" lazy>
              <b-card-text>
                <pie-chart
                  :height="null"
                  :width="null"
                  :chartData="chartDataIncoming"/>
              </b-card-text>
            </b-tab>
          </b-tabs>

        </b-card>


      </b-col>

    </b-row>

  </b-col>
</template>

<script>
import Api from '@/lib/Api';
import { store } from '@/store';
import PieChart from '@/components/PieChart';
import ShortStats from '@/components/ShortStats';


export default {
    name: 'ProjectMain',
    components: {
        PieChart,
        ShortStats
    },
    props: [
        'projectId',
    ],
    data () {
        return {
            appState: store.state,
            loading: false,
            stats: {},
        }
    },
    created () {
        this.loadData();
    },
    watch: {
        '$route': 'loadData'
    },
    computed: {
        project () {
            return store.findProject(parseInt(this.projectId))
        },
        chartDataAll () {
            if (!this.stats) {
                return null;
            }
            return {
                labels: ['Входящие', 'Исходящие'],
                datasets: [{
                    data: [this.stats.incoming, this.stats.outgoing],
                    backgroundColor: ['#17a2b8', '#007bff']
                }]
            };
        },
        chartDataIncoming () {
            if (!this.stats) {
                return null;
            }
            return {
                labels: ['Другие номера', 'Call-tracking'],
                datasets: [{
                    data: [this.stats.calls, this.stats.tracking_calls],
                    backgroundColor: ['red', 'blue']
                }]
            };
        }
    },
    methods: {
        async loadData () {
            this.loading = true;
            try {
                const stats = await Api.getShortStats(parseInt(this.projectId));
                this.stats = stats;
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка загрузки статистики', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loading = false;
        },
    }
}
</script>

<style scoped lang="scss">

 .stats-card .d-flex strong {
     font-size: 1.5rem;
 }
 
</style>
